
<div class="tw:flex tw:flex-wrap tw:p-0 tw:m-0 tw:h-full">

  <div class="tw:w-full tw:p-0 tw:m-0 tw:px-2">

    <div class="tw:flex tw:flex-nowrap tw:justify-center tw:items-center">

      <!--CURRENT SESSION BLOCKS-->
      @for (currentGroup of sessionBlocksCurrent | itemsPer: 3; track currentGroup) {
        <div class="tw:px-1 tw:text-center" #scrollMe>
          @for (currentSessionBlock of currentGroup; track currentSessionBlock) {
            <div class="tw:p-2 tw:mb-2 session-block-item-container"
              [ngClass]="{'session-block-disabled': currentSessionBlock.disabled && !currentSessionBlock.selected, 'session-block-item': !currentSessionBlock.disabled && !currentSessionBlock.selected, 'session-block-selected': currentSessionBlock.selected  }">
              <div class="tw:mb-2">
                <app-session-status-pill [status]="currentSessionBlock.status"></app-session-status-pill>
              </div>
              <div class="tw:flex tw:flex-wrap tw:-mx-[15px]"
                [ngClass]="{'cursor-not-allowed': currentSessionBlock.disabled }">
                <div class="tw:flex-1 tw:p-0 tw:m-0"
                  [ngClass]="{'cursor-not-allowed': currentSessionBlock.disabled }">
                  <label class="session-block-label"
                    [ngClass]="{'cursor-not-allowed': currentSessionBlock.disabled }">
                    {{currentSessionBlock.startDate | date: 'dd MMM yyyy'}}
                  </label>
                </div>
              </div>
              <div class="tw:flex tw:flex-wrap tw:-mx-[15px]"
                [ngClass]="{'cursor-not-allowed': currentSessionBlock.disabled }">
                <div class="tw:flex-1 tw:p-0 tw:m-0"
                  [ngClass]="{'cursor-not-allowed': currentSessionBlock.disabled }">
                  <label class="session-block-label"
                    [ngClass]="{'cursor-not-allowed': currentSessionBlock.disabled }">
                    {{currentSessionBlock.startTime.length > 5 ? currentSessionBlock.startTime.slice(0, -3) : currentSessionBlock.startTime}} -
                    {{currentSessionBlock.endTime.length > 5 ? currentSessionBlock.endTime.slice(0, -3) : currentSessionBlock.endTime}}
                  </label>
                </div>
              </div>
            </div>
          }
        </div>
      }
      <!--CURRENT SESSION BLOCKS-->

      <div class="show-future-button-container" [ngClass]="{'tw:hidden': !hideFutureBlocks}">
        <button type="button" (click)="hideFutureBlocks = false">Show</button>
      </div>

      <!--FUTURE SESSION BLOCKS-->
      @for (futureGroup of sessionBlocksFuture | itemsPer: 3; track futureGroup) {
        <div class="tw:px-1 tw:text-center"
          [ngClass]="{'tw:hidden': hideFutureBlocks}">
          @for (futureSessionBlock of futureGroup; track futureSessionBlock) {
            <div class="tw:p-2 tw:mb-2 session-block-item-container"
              [ngClass]="{'session-block-disabled': futureSessionBlock.disabled && !futureSessionBlock.selected, 'session-block-item': !futureSessionBlock.disabled && !futureSessionBlock.selected, 'session-block-selected': futureSessionBlock.selected  }">
              <div class="tw:mb-2">
                <app-session-status-pill [status]="futureSessionBlock.status"></app-session-status-pill>
              </div>
              <div class="tw:flex tw:flex-wrap tw:-mx-[15px]"
                [ngClass]="{'cursor-not-allowed': futureSessionBlock.disabled }">
                <div class="tw:flex-1 tw:p-0 tw:m-0"
                  [ngClass]="{'cursor-not-allowed': futureSessionBlock.disabled }">
                  <label class="session-block-label"
                    [ngClass]="{'cursor-not-allowed': futureSessionBlock.disabled }">
                    {{futureSessionBlock.startDate | date: 'dd MMM yyyy'}}
                  </label>
                </div>
              </div>
              <div class="tw:flex tw:flex-wrap tw:-mx-[15px]"
                [ngClass]="{'cursor-not-allowed': futureSessionBlock.disabled }">
                <div class="tw:flex-1 tw:p-0 tw:m-0"
                  [ngClass]="{'cursor-not-allowed': futureSessionBlock.disabled }">
                  <label class="session-block-label"
                    [ngClass]="{'cursor-not-allowed': futureSessionBlock.disabled }">
                    {{futureSessionBlock.startTime.length > 5 ? futureSessionBlock.startTime.slice(0, -3) : futureSessionBlock.startTime}} -
                    {{futureSessionBlock.endTime.length > 5 ? futureSessionBlock.endTime.slice(0, -3) : futureSessionBlock.endTime}}
                  </label>
                </div>
              </div>
            </div>
          }
        </div>
      }
      <!--FUTURE SESSION BLOCKS-->

    </div>
  </div>

</div>






<!--
<div class="row p-0 m-0 h-100">

  <div class="col-1 p-0 m-0">
    <a class="carousel-control-prev cursor-pointer" (click)="sessionBlockChange('previous')" data-slide="prev"
      [ngClass]="{'disabled-link': sessionBlockPageNumber == 1}">
      <span class="carousel-control-prev-icon"></span>
    </a>
  </div>

  <div class="col-10 p-0 m-0">

    <div class="row p-0 m-0 justify-content-center align-items-center">

      <div class="col-12 col-md-6 my-2 px-2 text-center"
        *ngFor="let sessionBlock of sessionBlocks; let i = index">
        <div class="p-3"
          [ngClass]="{'session-block-disabled': sessionBlock.disabled && !sessionBlock.selected, 'session-block-item': !sessionBlock.disabled && !sessionBlock.selected, 'session-block-selected': sessionBlock.selected  }"
          (click)="selectSessionBlock(sessionBlock, i)">
          <div class="cover">
                        <div [ngClass]="{'sleeve-new': sessionBlock.status == 'New',
                                        'sleeve-saved': sessionBlock.status == 'Saved',
                                        'sleeve-submitted': sessionBlock.status == 'Submitted',
                                        'sleeve-approved': sessionBlock.status == 'Approved',
                                        'sleeve-rejected': sessionBlock.status == 'Rejected'}"></div>
          </div>
          <div class="row"
            [ngClass]="{'cursor-not-allowed': sessionBlock.disabled }">
            <div class="col p-0 m-0"
              [ngClass]="{'cursor-not-allowed': sessionBlock.disabled }">
              <label class="session-block-label"
                [ngClass]="{'cursor-not-allowed': sessionBlock.disabled }">
                {{sessionBlock.startDate | date: 'dd MMM yyyy'}}
              </label>
            </div>
          </div>
          <div class="row"
            [ngClass]="{'cursor-not-allowed': sessionBlock.disabled }">
            <div class="col p-0 m-0"
              [ngClass]="{'cursor-not-allowed': sessionBlock.disabled }">
              <label class="session-block-label"
                [ngClass]="{'cursor-not-allowed': sessionBlock.disabled }">
                {{sessionBlock.startTime.length > 5 ? sessionBlock.startTime.slice(0, -3) : sessionBlock.startTime}} -
                {{sessionBlock.endTime.length > 5 ? sessionBlock.endTime.slice(0, -3) : sessionBlock.endTime}}
              </label>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="col-1 p-0 m-0">
    <a class="carousel-control-next cursor-pointer" (click)="sessionBlockChange('next')" data-slide="prev"
      [ngClass]="{'disabled-link': lastSessionBlockPage}">
      <span class="carousel-control-next-icon"></span>
    </a>
  </div>

</div> -->